module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.deleted_at === null) ? _c('div', {
    staticClass: "component-reject-driver-request-buttons"
  }, [_c('CreateBookingFromReservationRequest', {
    attrs: {
      "item": _vm.item
    }
  }), _c('UpdateDriverReservationRequestStatus', {
    attrs: {
      "item": _vm.item
    }
  }), _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.reject,
      "confirm": "confirm"
    }
  }, [_vm._v("Delete request")])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1508b52c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/DriverReservationRequestButtons.vue
// module id = 2160
// module chunks = 1